"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteCreator = void 0;
exports.deleteCreator = (function (writeBatch) {
    return function (reference) {
        var ref = writeBatch.delete(reference);
        return ref;
    };
});
